import { useSyncExternalStore } from 'react';
import { readJSON, writeJSON } from '../lib/storage';

const KEY = 'lsearch-recent-searches';
const MAX = 8;

// Module-level store so the search box and the start page stay in sync.
let recent = (() => {
  const stored = readJSON(KEY, []);
  return Array.isArray(stored) ? stored.filter((s) => typeof s === 'string').slice(0, MAX) : [];
})();
const listeners = new Set();

const emit = (next) => {
  recent = next;
  writeJSON(KEY, next);
  listeners.forEach((l) => l());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const addRecentSearch = (term) => {
  const clean = (term || '').trim();
  if (!clean) return;
  emit([clean, ...recent.filter((t) => t.toLowerCase() !== clean.toLowerCase())].slice(0, MAX));
};

export const removeRecentSearch = (term) => emit(recent.filter((t) => t !== term));

export const clearRecentSearches = () => emit([]);

/** Recent search terms, most recent first, stored in this browser only. */
export const useRecentSearches = () => useSyncExternalStore(subscribe, () => recent);
